'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

import PartnerNotFound from
  '@/app/(main)/(pages)/(institucional)/(index)/parceiros/_components/partner-not-found.component';
import ProfessionalNotFound from
  '@/app/(main)/(pages)/(institucional)/(index)/profissionais/[slug]/_components/professional-not-found.component';
import EmptyState from '@/app/(main)/_components/empty-state/empty-state';
import { Breadcrumb } from '@/components/ui/breadcrumb.component';
import { getLogger } from '@/logger/logger';

export default function NotFoundState() {
  const pathname = usePathname();
  const isProfessionalRoute = pathname?.includes('/profissionais/');
  const isPartnerRoute = pathname?.includes('/parceiros/');

  useEffect(() => {
    const logger = getLogger('not-found-state');
    logger.info('Rendered the not-found page', {
      app: { event: 'not_found_rendered', route: pathname },
    });
  }, [pathname]);

  return (
    <>
      {isProfessionalRoute && (
        <>
          <Breadcrumb
            list={[
              {
                label: 'Profissionais',
                href: '/profissionais/',
              },
              {
                label: '404',
              },
            ]}
          />
          <ProfessionalNotFound />
        </>
      )}

      {isPartnerRoute && (
        <>
          <Breadcrumb
            list={[
              {
                label: 'Rede de atendimento',
                href: '/rede-de-atendimento/',
              },
              {
                label: '404',
              },
            ]}
          />
          <PartnerNotFound />
        </>
      )}

      {!isProfessionalRoute && !isPartnerRoute && (
        <>
          <Breadcrumb
            list={[
              {
                label: 'Página não encontrada',
                href: '/',
              },
            ]}
          />
          <EmptyState
            title="Página não encontrada"
            description="A página que você está procurando não existe ou foi movida."
            button={{
              label: 'Página inicial',
              href: '/',
            }}
          />
        </>
      )}
    </>
  );
}
